import {
  addIds,
  ALL_MODULES,
  formatQuery,
  getTranslatedText,
  QueryBuilder,
  renamePropertyInRuleGroup,
  COMMON_CONSTANTS,
  checkInactiveField
} from '@nile/components';
import {
  AccountClient,
  apiMethodAndKeyNames,
  apiResolver,
  GET_FIELD,
  GET_REQUESTERS_BY_CRITERIA,
  GET_TECHNICIANS_BY_CRITERIA,
  TicketClient
} from '@nile/graphql';
//import '@nile/components/Builder/rule-builder/query-builder.scss';
import { cloneDeep, includes, isEmpty, pick } from 'lodash';
import nanoid from 'nanoid';
import React, { Component, useEffect, useState } from 'react';
import 'react-awesome-query-builder/css/compact_styles.scss';
import 'react-awesome-query-builder/css/styles.scss';
import { injectIntl } from 'react-intl';

class SLARuleBuilder extends Component {
  render() {
    return <RuleBuilder {...this.props} />;
  }
}

function RuleBuilder(props) {
  const appendProperties = (query) => {
    query = renamePropertyInRuleGroup(query, 'joinOperator', 'combinator');
    query = renamePropertyInRuleGroup(query, 'attribute', 'field');
    query = renamePropertyInRuleGroup(query, 'operands', 'rules');
    query = addIds(query);
    return query;
  };
  let inputQuery = cloneDeep(props.query);
  if (!isEmpty(inputQuery)) {
    inputQuery = appendProperties(inputQuery);
  }

  let preparedQueries = !isEmpty(inputQuery)
    ? inputQuery
    : {
        id: `g-${nanoid()}`,
        rules: [],
        combinator: 'AND',
        not: false
      };
  let preparedFields = [];
  const operatorComponentMap = {
    is: 'select',
    isNot: 'select',
    isEmpty: null,
    isNotEmpty: null,
    startsWith: 'text',
    endsWith: 'text',
    contains: 'text',
    notContains: 'text',
    includes: 'multiselect',
    notIncludes: 'multiselect',
    greaterThan: 'text',
    greaterThanOrEqual: 'text',
    lessThan: 'text',
    lessThanOrEqual: 'text',
    on: 'select',
    between: 'dual_date_picker',
    inNext: 'select',
    inLast: 'select',
    notInLast: 'unit',
    after: 'datepicker',
    before: 'datepicker'
  };
  const [query, setQuery] = useState(preparedQueries);
  const [fields, setFields] = useState([]);
  const [format, setFormat] = useState('json');
  const [allEntityFieldsMap, setEntityFieldMap] = useState({});
  const [entities, setEntities] = useState({});
  const { allEntities, allOperators, slaMeta, context, intl } = props;
  const processedOperators = cloneDeep(
    allOperators.getRuleBuilderOperators.operators
  );
  Object.keys(processedOperators).forEach((key) => {
    processedOperators[key] = getTranslatedText(intl, processedOperators[key]);
  });
  useEffect(() => {
    let parsedEntities = cloneDeep(allEntities);
    parsedEntities.getEntitiesMeta = parsedEntities.getEntitiesMeta.map(
      (metaEntity) => {
        return {
          ...metaEntity,
          attributes: metaEntity.attributes.map((field) => {
            return {
              ...field,
              label: getTranslatedText(intl, field.label || field.name)
            };
          })
        };
      }
    );

    preparedFields = parsedEntities
      ? parsedEntities.getEntitiesMeta
          .find((el) => el.name === 'Ticket')
          .attributes.filter((item) => {
            return slaMeta.getTicketSLAMetaInfo.conditionAttributes.some(
              (el) => el.name === item.name
            );
          })
      : [];

    let groupedFields = [];
    let entityFields = preparedFields.filter(
      (item) => item.dataType === 'entity'
    );
    let entityFieldSuggestedProperties = {};
    entityFieldSuggestedProperties = {};
    for (let i = 0; i < entityFields.length; i++) {
      let conditionField = slaMeta.getTicketSLAMetaInfo.conditionAttributes.find(
        (el) => el.name === entityFields[i].name
      );
      let allowedFieldsForEntity = conditionField.fields;
      let ca = [];
      for (let j = 0; j < allowedFieldsForEntity.length; j++) {
        let val = parsedEntities.getEntitiesMeta
          .find((el) => el.name === entityFields[i].entity)
          .attributes.find((arr) => {
            return arr.name === allowedFieldsForEntity[j].name;
          });
        ca.push({
          ...val,
          label: getTranslatedText(intl, val.attributePlaceHolder.label),
          name: entityFields[i].name + '.' + val.name
        });
      }
      entityFieldSuggestedProperties[entityFields[i].name] = ca;
    }
    for (let prop in entityFieldSuggestedProperties) {
      preparedFields = preparedFields.concat(
        entityFieldSuggestedProperties[prop]
      );
    }
    entityFieldSuggestedProperties['ticket'] = parsedEntities.getEntitiesMeta
      .find((el) => el.name === 'Ticket')
      .attributes.filter((item) => {
        return (
          slaMeta.getTicketSLAMetaInfo.conditionAttributes.some(
            (el) => el.name === item.name
          ) && item.dataType !== 'entity'
        );
      });
    setEntityFieldMap(entityFieldSuggestedProperties);
    setFields(preparedFields);
    setEntities(parsedEntities);
  }, []);

  /**
   * Reloads a prepared query, a PoC for query updates by props change.
   * If no target is supplied, clear query (generic query).
   */

  const isRuleGroup = (ruleOrGroup) => {
    return !!(ruleOrGroup.combinator && ruleOrGroup.rules);
  };

  const findRule = (field, parent) => {
    if (parent.field === field) {
      return parent;
    }

    for (const rule of parent.rules) {
      if (rule.field === field) {
        return rule;
      } else if (isRuleGroup(rule)) {
        const subRule = findRule(field, rule);
        if (subRule) {
          return subRule;
        }
      }
    }
  };

  const deleteRule = (field, parent) => {
    for (let rule of parent.rules) {
      if (rule.field === field) {
        parent.rules = parent.rules.filter((item) => item.field !== field);
      } else if (isRuleGroup(rule)) {
        const subRule = deleteRule(field, rule);
        if (subRule) {
          return subRule;
        }
      }
    }
    return parent;
  };

  const handleQueryChange = (query) => {
    setQuery(query);
    const formattedRule = formatQuery(query, 'json');
    context.updateSLAPolicy(formattedRule, 'slaCondition');
    console.log(context);
  };

  const getOperators = (field) => {
    const allFields = fields;
    const selectedField = allFields.find((el) => el.name === field);
    const operators = processedOperators;
    const operatorMap = allOperators.getRuleBuilderOperators.operatorType;
    if (
      selectedField &&
      Object.keys(selectedField).length &&
      selectedField.dataType !== 'entity'
    ) {
      const requiredOperators = pick(
        operators,
        operatorMap[selectedField.dataType]
      );
      const formattedOperatorValues = [];
      for (let prop in requiredOperators) {
        let _obj = {
          name: prop,
          label: requiredOperators[prop]
        };
        formattedOperatorValues.push(_obj);
      }
      return formattedOperatorValues;
    }
    return [];
  };

  const getGroupedFields = (fields) => {
    let groupedFields = [];
    for (let prop in allEntityFieldsMap) {
      groupedFields.push({
        label: prop + ' fields',
        options: allEntityFieldsMap[prop]
      });
    }
    return groupedFields;
  };

  const getValueEditorType = (field, operator) => {
    const selectedField = fields.find((el) => el.name === field);
    if (!operator) return null;
    if (
      includes(
        ['text', 'read_only', 'numeric', 'decimal'],
        selectedField?.filterType
      )
    ) {
      switch (operator) {
        case 'isEmpty':
        case 'isNotEmpty':
          return null;
        case 'includes':
        case 'notIncludes':
          return 'multi_select_text';
        default:
          return 'text';
      }
    }
    if (selectedField?.autoComplete) {
      switch (operator) {
        case 'is':
        case 'isNot':
          return 'search_select';
        case 'includes':
        case 'notIncludes':
          return 'multi_search_select';
        case 'isEmpty':
        case 'isNotEmpty':
          return null;
        case 'startsWith':
        case 'endsWith':
        case 'contains':
        case 'notContains':
          return 'text';
        default:
          return selectedField?.filterType || 'text';
      }
    }
    return operatorComponentMap[operator];
  };

  const getInputType = (field, operator) => {
    const selectedField = fields.find((el) => el.name === field);
    if (!operator) return null;
    if (includes(['numeric', 'decimal'], selectedField?.filterType)) {
      return 'number';
    }

    return operatorComponentMap[operator];
  };

  function getQuery(item) {
    const entity = item?.name?.split('.')[0] || '';
    switch (entity) {
      case 'technician':
      case 'followers':
        return GET_TECHNICIANS_BY_CRITERIA;
      default:
        return GET_REQUESTERS_BY_CRITERIA;
    }
  }

  function getNameKey(item) {
    const entity = item?.split('.')[0] || '';
    switch (entity) {
      case 'technician':
      case 'followers':
        return 'getTechnicianList';
      default:
        return 'getRequesterList';
    }
  }

  function getPropValues(item) {
    if (item?.name) {
      if (item.isCustom) {
        return AccountClient.query({
          query: GET_FIELD,
          variables: {
            input: {
              columnName: item?.columnName || item?.name,
              module: ALL_MODULES.ticket
            }
          }
        });
      }
      const query = apiResolver.Ticket[item.name]?.api;
      const client = apiResolver.Ticket[item.name]?.client;
      let variables = apiResolver.Ticket[item.name]?.variables || {};
      if (item.name === 'client.name') {
        variables = {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        };
      }
      return query && client
        ? client.query({
            query: query,
            variables: variables
          })
        : { client: AccountClient, query: getQuery(item) };
    }
    return {};
    // return response;
  }

  async function getValues(field) {
    const allFields = fields;
    const selectedField = allFields.find((el) => el.name === field);
    if (field.split('.')?.length > 1) {
      const ent = field.split('.')[0];
      if (ent !== 'techGroup' && ent !== 'client')
        return getPropValues(selectedField);
    }
    const allValues = await getPropValues(selectedField);
    let res = [];

    const selectedFieldName = selectedField?.name;

    if (selectedFieldName) {
      let method = apiMethodAndKeyNames[selectedFieldName]?.method;
      const secondaryMethod =
        apiMethodAndKeyNames[selectedFieldName]?.secondaryMethod;
      let key = apiMethodAndKeyNames[selectedFieldName]?.key;
      const nestedKey = apiMethodAndKeyNames[selectedFieldName]?.nestedKey;
      let dataToMap = [];
      if (secondaryMethod) {
        dataToMap = allValues.data[method]?.[secondaryMethod];
      } else {
        dataToMap = allValues.data[method];
      }

      if (selectedField.nestedTo) {
        let nestedProp = apiMethodAndKeyNames[selectedFieldName]?.nestedKey;
        if (!dataToMap && !method) {
          dataToMap = allValues.data?.getField?.options;
        }
        dataToMap.forEach((el) => {
          if (el[nestedProp]) {
            res = res.concat(
              el[nestedProp].map((c) => {
                return {
                  name: c[key],
                  value: c[key],
                  label: c[key]
                };
              })
            );
          } else {
            res = res.concat([
              { name: el?.value, value: el?.value, label: el?.value }
            ]);
          }
        });
      } else if (selectedField.isCustom) {
        method = 'getField';
        const fldOptions =
          allValues?.data?.[method]?.options ||
          allValues?.data?.[method]?.fieldOptions;
        res = allValues.data
          ? fldOptions?.map((el) => {
              return {
                name: el?.value,
                value: el?.value,
                label: el?.value
              };
            })
          : [];
      } else if (nestedKey) {
        dataToMap = dataToMap?.[nestedKey];
        res = dataToMap
          ? dataToMap.map((el) => {
              return {
                name: el[key],
                value: el[key],
                label: el[key]
              };
            })
          : [];
      } else {
        res = dataToMap
          ? dataToMap.map((el) => {
              return {
                name: el[key],
                value: el[key],
                label: el[key]
              };
            })
          : [];
      }
    }
    return res;
  }

  const fetchValues = async (client, query, params) => {
    const attribute = params?.field?.split('.')[1];
    const nameKey = getNameKey(params.field);
    const variables = {
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: attribute || 'firstName',
              operator: 'startsWith',
              value: params.inputValue
            }
          ]
        }
      }
    };
    const res = await client.query({
      query: query,
      variables: COMMON_CONSTANTS.IS_INSIDE_INPUT_VARIABLES[nameKey]
        ? { input: variables }
        : variables
    });
    const allOptions = res?.data?.[nameKey]
      ? res.data[nameKey].userList.map((el) => {
          return {
            name: `${el[attribute]}`,
            value: `${el[attribute]}`,
            label: `${el[attribute]}`
          };
        })
      : [];

    console.log(allOptions);
    return allOptions;
  };

  return (
    <div className="flex-box-outer">
      <div className="flex-box">
        <div className="scroll">
          <QueryBuilder
            query={query}
            fields={fields}
            isFieldGrouped
            onQueryChange={handleQueryChange}
            getOperators={getOperators}
            getGroupedFields={getGroupedFields}
            getValueEditorType={getValueEditorType}
            getInputType={getInputType}
            getValues={async function(item) {
              let result = await getValues(item);
              return result;
            }}
            async
            fetchValues={async function(client, query, params) {
              let result = await fetchValues(client, query, params);
              return result;
            }}
            showCombinatorsBetweenRules
            showNotToggle={false}
            resetOnFieldChange
            operatorComponentMap={operatorComponentMap}
            errors={props.errors}
            checkInactiveField={checkInactiveField({
              module: 'ticket',
              allEntities: allEntities,
              allOperators: allOperators,
              intl: intl
            })}
          />
        </div>
        {/* <pre>{formatQuery(query, format)}</pre> */}
      </div>
    </div>
  );
}

export default injectIntl(SLARuleBuilder);
